/**
 * IMPORTS
 */

import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";

import { FileQuestion, TriangleAlert } from "lucide-react";

import { Button } from "@components/button/button";

type MensagemErroProps = {
  icon: React.ReactNode;
  titulo: string;
  descricao: string;
};

function MensagemErro({ icon, titulo, descricao }: MensagemErroProps) {
  const navigate = useNavigate();

  return (
    <div className="flex h-full min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center">
      {icon}
      <h2 className="text-xl font-semibold text-gray-800">{titulo}</h2>
      <p className="max-w-md text-sm text-gray-500">{descricao}</p>
      <div className="mt-2 flex gap-2">
        <Button size="sm" variant="outline" onClick={() => navigate(-1)}>
          Voltar
        </Button>
        <Button size="sm" onClick={() => navigate("/", { replace: true })}>
          Ir para o início
        </Button>
      </div>
    </div>
  );
}

/** URL que não existe para o usuário logado. */
function PaginaNaoEncontrada() {
  return (
    <MensagemErro
      icon={<FileQuestion className="size-12 text-gray-400" />}
      titulo="Página não encontrada"
      descricao="O endereço acessado não existe ou não está disponível para o seu usuário."
    />
  );
}

/** errorElement das rotas: cobre 404 e erros inesperados ao renderizar uma tela. */
function RouteError() {
  const error = useRouteError();

  if (isRouteErrorResponse(error) && error.status === 404) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <PaginaNaoEncontrada />
      </div>
    );
  }

  console.error(error);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <MensagemErro
        icon={<TriangleAlert className="size-12 text-red-600" />}
        titulo="Algo deu errado"
        descricao="Ocorreu um erro inesperado ao carregar esta tela. Tente novamente em instantes."
      />
    </div>
  );
}

/**
 * EXPORTS
 */
export { PaginaNaoEncontrada, RouteError };
